/**
 * Owner: Masa Bayu
 * File: library-projection.ts
 * Date:Time: 2026-09-15 23:21
 * Description: T4 library shelves — purchased, continue, completed from items.
 */
import { projectEntitlementToLibraryItem } from './library-item';
import { assertT4E1SecurityIntact } from './library-security';
import { assertValidId } from './guards';
export function projectLibraryFromEntitlements(input) {
    assertT4E1SecurityIntact();
    assertValidId(input.accountId, 'QXRead library projection accountId');
    const items = [];
    for (const entitlement of input.entitlements) {
        if (entitlement.accountId !== input.accountId) {
            throw new Error('QXRead library projection denies cross-account entitlement');
        }
        const existing = input.existingItemsByEntitlementId?.get(entitlement.entitlementId);
        if (existing !== undefined) {
            if (existing.accountId !== input.accountId) {
                throw new Error('QXRead library projection denies cross-account library item');
            }
            items.push(existing);
            continue;
        }
        const catalog = input.catalogByPublicationId.get(entitlement.publicationId);
        if (catalog === undefined) {
            throw new Error(`QXRead library projection missing catalog snapshot for ${entitlement.publicationId}`);
        }
        items.push(projectEntitlementToLibraryItem(entitlement, {
            title: catalog.title,
            qxpPublicationRef: catalog.qxpPublicationRef,
            pinnedVersionLabel: catalog.pinnedVersionLabel ?? null,
            listedVersionLabel: catalog.listedVersionLabel ?? null,
        }));
    }
    const purchased = Object.freeze(items.filter((item) => item.state !== 'removed' &&
        item.state !== 'blocked' &&
        item.state !== 'materializing' &&
        item.state !== 'archived'));
    const continueReading = Object.freeze(items
        .filter((item) => item.progress.state === 'in_progress' &&
        item.state !== 'blocked' &&
        item.state !== 'removed')
        .slice()
        .sort((left, right) => {
        const leftAt = left.progress.lastOpenedAt ?? '';
        const rightAt = right.progress.lastOpenedAt ?? '';
        return rightAt.localeCompare(leftAt);
    }));
    const completed = Object.freeze(items.filter((item) => item.progress.state === 'completed' || item.state === 'completed'));
    const blocked = Object.freeze(items.filter((item) => item.state === 'blocked'));
    const archived = Object.freeze(items.filter((item) => item.state === 'archived'));
    const wishlist = Object.freeze((input.wishlist ?? []).filter((item) => item.accountId === input.accountId && item.state === 'active'));
    return Object.freeze({
        accountId: input.accountId,
        purchased,
        continueReading,
        completed,
        blocked,
        archived,
        wishlist,
        projectedAt: input.projectedAt ?? new Date().toISOString(),
    });
}
//# sourceMappingURL=library-projection.js.map